import React, { useState,useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Grid, Paper,Skeleton,Button } from "@mui/material";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { ArrowUpward, ArrowDownward, TrendingUp, TrendingDown, AttachMoney,MonetizationOn, BarChart } from '@mui/icons-material';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth,firestore } from "../../../firebaseConfig"; // Import the Firebase auth module
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";


function StockTable({ stockInfo }) {
  const navigate = useNavigate();

  // const getStockInfo = (symbol, changeType) => {
  //   const change = dailyChanges.find(change => change.symbol === symbol);
  //   return change ? (change[changeType] !== 'N/A' ? change[changeType]?.toFixed(2) + '%' : 'N/A') : 'N/A';
  // };
  const [user, setUser] = useState(null); // Store user details
  const [paiduser, setUserPaid] = useState(null); // Store Firestore name

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser); // Set Firebase auth user data

        // Fetch user details from Firestore
        const userDocRef = doc(firestore, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          if (userData.isPaidUserFlag) {
          setUserPaid(true);
          } // Set the name from Firestore
        }
      } else {
        setUser(null);
        setUserPaid(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, []);



  const getStockInfo1 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change[changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const getStockInfo2 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change['recommendations'][changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const getStockInfo3 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const target_low = change['target_low'];
      const target_high = change['target_high'];
      const target_mean = change['target_mean'];
      const current_price = change['current_price'];
      const value = (target_low - current_price)/current_price
      console.log("value",value)
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const getStockInfo4 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change['options_diff'][changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const formatNumber = (value) => {
    return Math.round(value).toLocaleString();
  };

  const isValidNumber = (value) => {
    return typeof value === 'number' && !isNaN(value);
  };

  const renderRecommendationChart = (stock) => {
 


    const recommendations = getStockInfo1(stock.symbol, 'recommendations') || {};
    const strongBuy = recommendations.strongBuy || 0;
    const buy = recommendations.buy || 0;
    const hold = recommendations.hold || 0;
    const sell = recommendations.sell || 0;
    const strongSell = recommendations.strongSell || 0;

    const allZero = strongBuy === 0 && buy === 0 && hold === 0 && sell === 0 && strongSell === 0;

    if (allZero) {
      // Fallback: Display text instead of the chart
      return (
        <div>
          Strong Buy: {strongBuy}<br />
          Buy: {buy}<br />
          Hold: {hold}<br />
          Sell: {sell}<br />
          Strong Sell: {strongSell}
        </div>
      );
    }
  
    // Prepare the data for the chart
    const data = [
      { name: 'Strong Buy', y: strongBuy, color: '#28a745' }, // Green
      { name: 'Buy', y: buy, color: '#85e085' }, // Light Green
      { name: 'Hold', y: hold, color: '#f1c40f' }, // Yellow
      { name: 'Sell', y: sell, color: '#ff5733' }, // Red
      { name: 'Strong Sell', y: strongSell, color: '#c70039' }, // Dark Red
    ];
  
    const options = {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: '100px',
      },
      title: {
        text: '',
      },
      tooltip: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          innerSize: '70%', // Donut-style chart
          borderWidth: 0, // No border
          dataLabels: {
            enabled: true,
            distance: 30, // Distance from the pie slice
            formatter: function () {
              if (this.y > 0) {
                return `<div style="
                  background-color: #ffffff; 
                  padding: 2px 5px;
                  border-radius: 4px; 
                  color: ${this.color}; 
                  font-family: 'Work Sans', sans-serif; 
                  font-size: 12px; 
                  font-weight: 500; 
                  text-align: center;
                  white-space: nowrap;">
                  ${this.point.name}: ${this.y}
                </div>`;
              }
              return null; // Don't display data labels for zero values
            },
            useHTML: true,
            style: {
              textOutline: 'none',
            },
            verticalAlign: 'middle',
            crop: false,
            overflow: 'allow',
          },
        },
        series: {
          animation: false, // Turn off animations for the series
        },
      },
      legend: {
        enabled: false, // Disable legend as data labels handle this
      },

      series: [
        {
          name: 'Recommendations',
          data,
        },
      ],
    };
  
    return <HighchartsReact highcharts={Highcharts} options={options} />;
  };

  const NewsCarousel = (stock) => {
    const newsData = getStockInfo1(stock.symbol, "news_data");
    
    // Check if newsData is valid
    if (!Array.isArray(newsData) || newsData.length === 0) {
      return (
        <div style={{ margin: "20px", textAlign: "center", color: "#555" }}>
          No News Available
        </div>
      );
    }
  
    const settings = {
      dots: false, // Hide navigation dots for cleaner vertical scrolling
      infinite: true, // Loop through items
      speed: 500, // Transition speed
      slidesToShow: 1, // Show 3 news cards at a time vertically
      slidesToScroll: 1, // Scroll one card at a time
      vertical: true, // Enable vertical scrolling
      verticalSwiping: true, // Allow vertical swiping
      autoplay: true, // Enable auto-scrolling
      autoplaySpeed: 2000, // Time between scrolls
      arrows: true, // Remove navigation arrows for cleaner UI
    };
  
    return (
      <div style={{ margin: "20px", maxWidth: "400px",  }}>
        <Slider {...settings}>
          {newsData.map((news) => (
            <div key={news.id} style={{ padding: "10px" }}>
              <div
                style={{
                  background: "#fff",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "12px",
                  textAlign: "left",
                  height: "120px", // Reduced height for compact rows
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <h3
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginBottom: "4px",
                    color: "#333",
                  }}
                >
                  {news.title}
                </h3>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#555",
                    marginBottom: "8px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {news.summary}
                </p>
                <a
                  href={news.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "12px",
                    color: "#007bff",
                    textDecoration: "none",
                    fontWeight: "500",
                  }}
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  };
  


 

  const renderPriceTargets = (stock) => {
    const targetLow = parseFloat(getStockInfo1(stock.symbol, 'target_low'));
    const targetHigh = parseFloat(getStockInfo1(stock.symbol, 'target_high'));
    const targetMean = parseFloat(getStockInfo1(stock.symbol, 'target_mean'));
    const currentPrice = parseFloat(getStockInfo1(stock.symbol, 'current_price'));
  
    if (isNaN(targetLow) || isNaN(targetHigh) || isNaN(targetMean) || isNaN(currentPrice)) {
      return <div>
      target_low: {getStockInfo1(stock.symbol, 'target_low')}<br />
      target_high: {getStockInfo1(stock.symbol, 'target_high')}<br />
      target_mean: {getStockInfo1(stock.symbol, 'target_mean')}<br />
      current_price: {getStockInfo1(stock.symbol, 'current_price')}<br />
  
      </div>;
    }
  
    const getPercentageChange = (target) =>
      (((target - currentPrice) / currentPrice) * 100).toFixed(2);
  
    const options = {
      chart: {
        type: 'line',
        backgroundColor: 'transparent',
        height: '200px', // Increased height for more space
        spacingTop: 20, // Add spacing to avoid crowding
        spacingBottom: 20,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        visible: false,
        min: 0,
        max: 3,
      },
      yAxis: {
        visible: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false,
          },
          lineWidth: 3,
          dataLabels: {
            enabled: true,
            distance: 0, // Adjust distance from points
            align: 'left', // Align labels to the right
            x: 0, // Offset to move the label slightly away from the line
            formatter: function () {
              if (this.point.x === 1) {
                const percentageChange = (((this.y - currentPrice) / currentPrice) * 100).toFixed(2);
          
                // Determine the title based on the series name
                let title = '';
                let displayText = '';
                switch (this.series.name) {
                  case 'Low Target':
                    title = 'Min';
                    displayText = `${title} ${this.y.toFixed(2)} (${percentageChange}%)`;
                    break;
                  case 'Mean Target':
                    title = 'Avg';
                    displayText = `${title} ${this.y.toFixed(2)} (${percentageChange}%)`;
                    break;
                  case 'High Target':
                    title = 'Max';
                    displayText = `${title} ${this.y.toFixed(2)} (${percentageChange}%)`;
                    break;
                  case 'Current Price':
                    title = 'Current';
                    displayText = `${title} ${this.y.toFixed(2)}`; // Exclude percentage change
                    break;
                  default:
                    break;
                }
          
                return `<div style="
                background-color: #ffffff; 
                
                border-radius: 4px; 
               
                color: ${this.series.color}; 
                font-family: 'Work Sans', sans-serif; 
                font-size: 12px; 
                font-weight: 500; 
                text-align: center;
                white-space: nowrap;">
                ${displayText}
              </div>`;
              }
              return null;
            },
            useHTML: true,
            verticalAlign: 'middle',
            crop: false, // Ensure labels are not cropped
            overflow: 'allow', // Allow labels to overflow the chart area
            style: {
              textOutline: 'none',
            },
          },
        },
        area: {
          fillOpacity: 1,
        },
        series: {
          animation: false, // Turn off animations for the series
        },
      },
      series: [
        {
          name: 'Current Price',
          data: [
            [0, currentPrice],
            [1, currentPrice],
          ],
          color: '#3498DB',
        },
        {
          name: 'Low Target',
          data: [
            [0, currentPrice],
            [1, targetLow],
          ],
          color: '#FF5733',
        },
        {
          name: 'Mean Target',
          data: [
            [0, currentPrice],
            [1, targetMean],
          ],
          color: '#F1C40F',
        },
        {
          name: 'High Target',
          data: [
            [0, currentPrice],
            [1, targetHigh],
          ],
          color: '#28A745',
        },
      ],
    };
  
    return <HighchartsReact highcharts={Highcharts} options={options} />;
  };

  const renderOptionDetails = (stock) => {
    const total_call_openinterest = getStockInfo1(stock.symbol, 'total_call_openinterest');
    const total_call_volume = getStockInfo1(stock.symbol, 'total_call_volume');
    const total_put_openinterest = getStockInfo1(stock.symbol, 'total_put_openinterest');
    const total_put_volume = getStockInfo1(stock.symbol, 'total_put_volume');
    const call_put_open_ratio = getStockInfo1(stock.symbol, 'call_put_open_ratio');
    const call_put_ratio = getStockInfo1(stock.symbol, 'call_put_ratio');
  
    return (
      <div style={{ padding: "16px", backgroundColor: "#f4f6f8", borderRadius: "12px" }}>
        
        {/* Call Open Interest */}
        <div style={{ fontSize: "14px", color: "#4caf50", display: "flex", alignItems: "center" }}>
    <ArrowUpward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Total Call Open Interest: {total_call_openinterest || "N/A"}</span>
  </div>

  {/* Total Call Volume */}
  <div style={{ fontSize: "14px", color: "#4caf50", display: "flex", alignItems: "center" }}>
    <ArrowUpward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Total Call Volume: {total_call_volume || "N/A"}</span>
  </div>

  {/* Total Put Open Interest */}
  <div style={{ fontSize: "14px", color: "#e53935", display: "flex", alignItems: "center" }}>
    <ArrowDownward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Total Put Open Interest: {total_put_openinterest || "N/A"}</span>
  </div>

  {/* Total Put Volume */}
  <div style={{ fontSize: "14px", color: "#e53935", display: "flex", alignItems: "center" }}>
    <ArrowDownward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Total Put Volume: {total_put_volume || "N/A"}</span>
  </div>

  {/* Call/Put Open Interest Ratio */}
  <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
    <ArrowUpward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Call/Put Open Interest Ratio: {call_put_open_ratio || "N/A"}</span>
  </div>

  {/* Call/Put Ratio */}
  <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
    <ArrowUpward style={{ verticalAlign: "middle" }} />
    <span style={{ marginLeft: "8px", verticalAlign: "middle" }}>Call/Put Ratio: {call_put_ratio || "N/A"}</span>
  </div>
  
      </div>
    );
  };

  const handleRowClick = (param) => {
    // Extract the stock symbol from the row data
    const symbol = param.row.symbol;
  
  // Open the Yahoo Finance page in a new tab
  window.open(`https://au.finance.yahoo.com/quote/${symbol}`, "_blank");
};

const formatNumber1 = (num) => {
  if (!num || isNaN(num)) return "N/A";
  num = parseFloat(num);

  if (Math.abs(num) >= 1.0e9) {
    return (num / 1.0e9).toFixed(2) + " B$";
  } else if (Math.abs(num) >= 1.0e6) {
    return (num / 1.0e6).toFixed(2) + " M$";
  } else if (Math.abs(num) >= 1.0e3) {
    return (num / 1.0e3).toFixed(2) + " K$";
  } else {
    return num.toFixed(2) + " $";
  }
};

const renderFinancial = (stock) => {
  // First Card - Valuation Metrics
  const forwardPE = getStockInfo1(stock.symbol, "forward_pe");
  const trailingPE = getStockInfo1(stock.symbol, "trailing_pe");
  const forwardEps = getStockInfo1(stock.symbol, "forwardEps");
  const trailingEps = getStockInfo1(stock.symbol, "trailingEps");

  // Second Card - Growth & Cash Flow Metrics
  const revenueGrowth = getStockInfo1(stock.symbol, "revenue_growth");
  const earningsGrowth = getStockInfo1(stock.symbol, "earnings_growth");
  const dividendYield = getStockInfo1(stock.symbol, "dividend_yield");
  const freeCashFlowRaw = getStockInfo1(stock.symbol, "free_cash_flow");
  const freeCashFlow = formatNumber1(freeCashFlowRaw);

  return (
    <div style={{ display: "flex", gap: "16px" }}>
      
      {/* First Card - Valuation Metrics */}
      <div style={{ flex: 1, padding: "16px", backgroundColor: "#f4f6f8", borderRadius: "12px", display: "flex", flexDirection: "column", gap: "8px" }}>
        
        <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
          <AttachMoney style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Forward P/E: {forwardPE ?? "N/A"}</span>
        </div>

        <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
          <AttachMoney style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Trailing P/E: {trailingPE ?? "N/A"}</span>
        </div>

        <div style={{ fontSize: "14px", color: "#4caf50", display: "flex", alignItems: "center" }}>
          <TrendingUp style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Forward EPS: {forwardEps ?? "N/A"}</span>
        </div>

        <div style={{ fontSize: "14px", color: "#4caf50", display: "flex", alignItems: "center" }}>
          <TrendingUp style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Trailing EPS: {trailingEps ?? "N/A"}</span>
        </div>

      </div>

      {/* Second Card - Growth & Cash Flow Metrics */}
      <div style={{ flex: 1, padding: "16px", backgroundColor: "#f4f6f8", borderRadius: "12px", display: "flex", flexDirection: "column", gap: "8px",width: "350px" }}>
        
        <div style={{ fontSize: "14px", color: revenueGrowth > 0 ? "#4caf50" : "#e53935", display: "flex", alignItems: "center" }}>
          {revenueGrowth > 0 ? <TrendingUp style={{ verticalAlign: "middle"}} /> : <TrendingDown style={{ verticalAlign: "middle" }} />}
          <span style={{ marginLeft: "8px" }}>Revenue Growth: {revenueGrowth*100 ?? "N/A"} %</span>
        </div>

        <div style={{ fontSize: "14px", color: earningsGrowth > 0 ? "#4caf50" : "#e53935", display: "flex", alignItems: "center" }}>
          {earningsGrowth > 0 ? <TrendingUp style={{ verticalAlign: "middle" }} /> : <TrendingDown style={{ verticalAlign: "middle" }} />}
          <span style={{ marginLeft: "8px" }}>Earnings Growth: {earningsGrowth*100 ?? "N/A"} %</span>
        </div>

        <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
          <MonetizationOn style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Dividend Yield: {dividendYield ?? "N/A"}</span>
        </div>

        <div style={{ fontSize: "14px", color: "#1976d2", display: "flex", alignItems: "center" }}>
          <BarChart style={{ verticalAlign: "middle" }} />
          <span style={{ marginLeft: "8px" }}>Free Cash Flow: {freeCashFlow ?? "N/A"}</span>
        </div>

      </div>

    </div>
  );
};














  // Define columns for the DataGrid
  const columns = [
    {
      field: "symbol",
      headerName: "Symbol",
      width: 200, // Increased width to accommodate the logo and symbol
      sortable: false,
      renderCell: (params) => {
        const website = params.row.companyWebsite.replace("https://", "").replace("http://", ""); // Clean website URL
        const logoUrl = `https://img.logo.dev/${website}?token=pk_ZEeufcgvTMe6FoAs8ob5hg&retina=true`;
  
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Logo */}
            <img
              src={logoUrl}
              alt={`${params.row.symbol} logo`}
              style={{
                
                height: "80px",
                marginRight: "8px",
                objectFit: "contain",
                borderRadius: "4px",
              }}
            />
            {/* Symbol */}
            <span>{params.row.symbol}</span>
          </div>
        );
      },
    },
    { field: "companyName", headerName: "Company Name", width: 200, sortable: false },
    { field: "rank", headerName: "Points", width: 100, type: "number", sortable: false },
{
  field: "hourlyConditions", 
  headerName: "Hourly Indicator", 
  width: 250,  // You can increase this width if necessary
  sortable: false, 
  renderCell: (params) => {
    const value = Array.isArray(params.value) ? params.value : params.value.split("\n");
    return (
      <div style={{ fontSize: '0.9em', whiteSpace: 'pre-wrap', width: '100%' }}>
        {value.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  },
},
{
  field: "dailyConditions", 
  headerName: "Daily Indicator", 
  width: 250,  // You can increase this width if necessary
  sortable: false, 
  renderCell: (params) => {
    const value = Array.isArray(params.value) ? params.value : params.value.split("\n");
    return (
      <div style={{ fontSize: '0.9em', whiteSpace: 'pre-wrap', width: '100%' }}>
        {value.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  },
},
{
  field: "prizeanalysis",
  headerName: "Prize Targets",
  width: 250,
  sortable: false,
  renderCell: (params) => {
    return renderPriceTargets(params.row);
  },
},
{
  field: "recommendation",
  headerName: "Analyst Recommendation",
  width: 350,
  sortable: false,
  renderCell: (params) => {
    return renderRecommendationChart(params.row);
  },
},

{
  field: "newsdata",
  headerName: "Latest News",
  width: 550,
  sortable: false,
  renderCell: (params) => {
    return NewsCarousel(params.row);
  },
},

{
  field: "optiondetails",
  headerName: "Option Details",
  width: 350,
  sortable: false,
  renderCell: (params) => {
    return renderOptionDetails(params.row);
  },
},

{
  field: "otherfinancial",
  headerName: "Financial Details",
  width: 650,
  sortable: false,
  renderCell: (params) => {
    return renderFinancial(params.row);
  },
},





  ];
  
  // Transform stocks data to match DataGrid's structure
  const rows = stockInfo.map((stock, index) => ({
    id: index,
    symbol: stock.symbol,
    companyWebsite: stock.company_website || "N/A",
    companyName: stock.company_name || "N/A",
    rank: stock.rank || "N/A",
    hourlyConditions: stock.hourly_conditions_satisfied || "N/A",
    dailyConditions: stock.daily_conditions_satisfied || "N/A",
    prizeanalysis: stock, // Pass the entire stock object for prize analysis
    recommendation: stock, // Pass the entire stock object for the pie chart
    newsdata: stock,
    optiondetails: stock,
    otherfinancial: stock,
  }));

  const displayedRows = paiduser ? rows : rows.slice(0, 4); // Show only 5 rows for free users



  return (
    <Box sx={{ height: "100vh", width: "100%", backgroundColor: "#f9f9f9", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",overflow: "hidden",position: "relative",paddingBottom: paiduser ? "0" : "77px" }}>
    {!paiduser && (
      <>
        {/* Subscribe Button */}
        <Box
          sx={{
            textAlign: "center",
            padding: "16px",
            
            backgroundColor: "#f0f0f0",
            borderRadius: "10px",
            
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              fontSize: 16,
              fontFamily: "'Work Sans', sans-serif",
              borderRadius: "20px",
              padding: "8px 24px",
            }}
            onClick={() => {
              navigate("/ManageSubscription");
            }}
          >
            Subscribe to view all
          </Button>
        </Box>
      </>
    )}
      <DataGrid
        rows={displayedRows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5, 10, 20]}
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#1e88e5", // Blue header
            color: "black",
            fontWeight: "500",
            fontSize: 16,
            fontFamily: "'Work Sans', sans-serif",
            textTransform: "uppercase", // Clean and modern look
            borderBottom: "1px solid #ddd", // Subtle border for header
            textAlign: "center", // Centered header text
            
          },
          "& .MuiDataGrid-cell": {
            fontSize: 14,
            fontFamily: "'Work Sans', sans-serif", // Modern and minimal font
            textAlign: "center", // Align text horizontally
            display: "flex", // Enable flexbox
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
            whiteSpace: "pre-wrap", 
            padding: "12px", // Adjust padding for better spacing
            borderBottom: "1px solid #f0f0f0", // Subtle border for rows
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: "#f0f0f0",
            fontFamily: "'Work Sans', sans-serif",
            fontSize: 14,
            fontWeight: 500,
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#e3f2fd", // Subtle hover effect
            cursor: "pointer",
          },
          "& .MuiDataGrid-row:first-of-type": {
            borderTop: "none", // Remove border for the first row
          },
        }}

        getRowHeight={() => 'auto'}
        onRowClick={handleRowClick}
      />



    </Box>
  );
}

export default StockTable;